// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1V21h","list":"styles_list__2EI5T"};